import { Component, Input, inject } from "@angular/core";
import { LinkModel } from "@models/generic/LinkModel";
import { RiskDataService } from "@app/risk/services/RiskDataService";
import { RiskModel } from "@app/risk/models/RiskModel";

@Component({
    selector: "risk-thirdparty",
    templateUrl: "./risk-thirdparty.component.html",
    standalone: false
})
export class RiskThirdpartyComponent {
    private _riskDS = inject(RiskDataService);

    @Input() risk: RiskModel;

    linked: LinkModel[] = [];
    unlinked: LinkModel[] = [];
    isLoading = true;

    load() {
        this.isLoading = true;
        this._riskDS.getLinkedThirdParties(this.risk.guid).subscribe(data => {
            this.linked = data;

            this.isLoading = false;
        });
    }
}
